function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "01A739AA-9FF4-4D2C-873B-991F05707138");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null);

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Desktop",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "02_Wallet_L_1440_Full",
  transform: "translate(-120.000000, -512.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Driver-License",
  transform: "translate(64.000000, 456.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Driver-License-Card",
  transform: "translate(56.000000, 56.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Card-BG",
  fill: "#304FFE",
  x: 0,
  y: 0,
  width: 214,
  height: 134,
  rx: 8
}), /*#__PURE__*/React.createElement("path", {
  d: "M115,42 L179,42 C180.656854,42 182,43.3431458 182,45 C182,46.6568542 180.656854,48 179,48 L115,48 C113.343146,48 112,46.6568542 112,45 C112,43.3431458 113.343146,42 115,42 Z M115,64 L179,64 C180.656854,64 182,65.3431458 182,67 C182,68.6568542 180.656854,70 179,70 L115,70 C113.343146,70 112,68.6568542 112,67 C112,65.3431458 113.343146,64 115,64 Z M115,86 L179,86 C180.656854,86 182,87.3431458 182,89 C182,90.6568542 180.656854,92 179,92 L115,92 C113.343146,92 112,90.6568542 112,89 C112,87.3431458 113.343146,86 115,86 Z",
  id: "Lines",
  fill: "#243ACB",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("g", {
  id: "Driver-License-Icon",
  transform: "translate(30.000000, 39.000000)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-7",
  fill: "#243ACB",
  x: 0,
  y: 8,
  width: 59,
  height: 48,
  rx: 4
}), /*#__PURE__*/React.createElement("path", {
  d: "M54,56 L4,56 L4,47.6 C4,39.8680135 10.2182674,33.6 17.8888889,33.6 L40.1111111,33.6 C47.7817326,33.6 54,39.8680135 54,47.6 L54,56 Z",
  id: "Combined-Shape",
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.1428571,33 C21.4284035,33 15.1746032,26.7319865 15.1746032,19 C15.1746032,11.2680135 21.4284035,5 29.1428571,5 C36.8573108,5 43.1111111,11.2680135 43.1111111,19 C43.1111111,26.7319865 36.8573108,33 29.1428571,33 Z",
  id: "Oval",
  fill: "#1C2CA2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.1428571,28 C21.4284035,28 15.1746032,21.7319865 15.1746032,14 C15.1746032,6.2680135 21.4284035,0 29.1428571,0 C36.8573108,0 43.1111111,6.2680135 43.1111111,14 C43.1111111,21.7319865 36.8573108,28 29.1428571,28 Z",
  id: "Oval-Copy",
  fill: "#FFFFFF"
}))))));

var SvgDriverLicense = function SvgDriverLicense(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "214px",
    height: "134px",
    viewBox: "0 0 214 134",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDriverLicense, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/driver-license.61bc9037.svg";
export { ForwardRef as ReactComponent };